import { mdiCheckboxBlankCircleOutline } from '@mdi/js'

const themeConfig = {
  app: {
    // name: 'PI-TOOLS',
    logo: require('@/assets/images/logo.png'),


    full_logo: require('@/assets/images/perkins.svg'),
    full_logo_white: require('@/assets/images/perkins_white.svg'),

    isDark: false,
    isRtl: false,
    contentLayoutNav: 'vertical', // vertical, horizontal
    routeTransition: 'scroll-x-transition', // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: 'default', // default, bordered, semi-dark
    contentWidth: 'boxed',
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: 'fixed', // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: 'static', // fixed, static, hidden
  },
  themes: {
    light: {
      primary: '#1d4f91',
      accent: '#0d6efd',
      secondary: '#8A8D93',
      success: '#00cc9f',
      info: '#06a6ea',
      warning: '#FFB400',
      error: '#E0004D',
      purple: '#84239b',
      'alt-primary': '#1d4f91',
    },
    dark: {
      primary: '#1D4F91',
      accent: '#0d6efd',
      secondary: '#F1F1F1',
      success: '#00e2b0',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#ff7075',
      purple: '#84239b',
      'alt-primary': '#e6e4ec',
    },
  },
}

export default themeConfig
